export const SLACK_SETTING_REQUEST = 'SLACK_SETTING_REQUEST'
export const SLACK_SETTING_SUCCESS = 'SLACK_SETTING_SUCCESS'
export const SLACK_SETTING_ERROR = 'SLACK_SETTING_ERROR'
export const SLACK_SETTING_SET = 'SLACK_SETTING_SET'

export const SLACK_SETTING_CREATE_REQUEST = 'SLACK_SETTING_CREATE_REQUEST'

export const SLACK_SETTING_DELETE_REQUEST = 'SLACK_SETTING_DELETE_REQUEST'
export const SLACK_SETTING_DELETE_SUCCESS = 'SLACK_SETTING_DELETE_SUCCESS'
export const SLACK_SETTING_DELETE_ERROR = 'SLACK_SETTING_DELETE_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/slack/slack-setting.type.js